export default "__VITE_ASSET__Z5A5ApDz__"